"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coreInfoBarReducer = exports.coreInfoBarActions = exports.TYPES_INFO_BAR = exports.INFOBAR_VARIANT = void 0;
var _reduxActions = require("redux-actions");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const CORE_INFO_BAR = 'coreInfoBar';
const TYPES_INFO_BAR = exports.TYPES_INFO_BAR = {
  OPEN: CORE_INFO_BAR + 'Open',
  CLOSE: CORE_INFO_BAR + 'Close'
};
const SUCCESS = 'success';
const WARNING = 'warning';
const ERROR = 'error';
const INFO = 'info';
const INFOBAR_VARIANT = exports.INFOBAR_VARIANT = Object.freeze({
  SUCCESS,
  WARNING,
  ERROR,
  INFO
});
const INIT_STATE = {
  type: undefined,
  message: '',
  isOpen: false
};
const coreInfoBarActions = exports.coreInfoBarActions = (0, _reduxActions.createActions)({
  [TYPES_INFO_BAR.OPEN]: function () {
    return {
      type: arguments.length <= 0 ? undefined : arguments[0],
      message: arguments.length <= 1 ? undefined : arguments[1]
    };
  }
}, TYPES_INFO_BAR.CLOSE);
const coreInfoBarReducer = exports.coreInfoBarReducer = (0, _reduxActions.handleActions)({
  [TYPES_INFO_BAR.OPEN]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      type: action.payload.type,
      message: action.payload.message,
      isOpen: true
    });
  },
  [TYPES_INFO_BAR.CLOSE]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      isOpen: false
    });
  }
}, INIT_STATE);